// 不同国家的 套餐/自定义服务/定制化服务 的申请步骤
export const applyStepData = {
  Singapore: {
    // 公司设立
    COMPANY_INCORPORATION: [
      {
        idx: 0, // 索引
        title: "enroll.intitle.intitle", // 标题
        defaultImg: require("@/assets/img/step/step01.png"), // 默认图片
        activeImg: require("@/assets/img/step/stepActive01.png"), // 选中图片
        currentPath: "/enroll/intitle", // 当前路径
        prevPath: null, // 上一步路径
        nextPath: "/enroll/questionnaire", // 下一步路径
        supportApplymentStatusMap: {
          list: ["DRAFT"], // 支持进入该页面的申请状态
          violateMessage: "common.warning.alreadySubmit", // 违反(不在支持申请状态列表中)进入该页面时，提示的信息
        },
        componentName: "EnrollIntitle", // 组件名称(用于affirm、detail页)
      },
      {
        idx: 1,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: "/enroll/intitle",
        nextPath: "/enroll/establish",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 2,
        title: "enroll.establish.establish",
        defaultImg: require("@/assets/img/step/step03.png"),
        activeImg: require("@/assets/img/step/stepActive03.png"),
        currentPath: "/enroll/establish",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollEstablish",
      },
      {
        idx: 3,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/establish",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 4,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 5,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
    // 公司服务的转移 – 公司秘书相关的服务
    SERVICE_TRANSFER: [
      {
        idx: 0,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: null,
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT"], // 支持进入该页面的申请状态
          violateMessage: "common.warning.alreadySubmit", // 违反(不在支持申请状态列表中)进入该页面时，提示的信息
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 1,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 2,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 3,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
    // 综合性公司服务 – 定制化(不包括:公司设立)
    COMPREHENSIVE_CUSTOMIZED: [
      {
        idx: 0,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: null,
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 1,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/quotation",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 2,
        title: "enroll.quotation.quotation",
        defaultImg: require("@/assets/img/step/step03-03.png"),
        activeImg: require("@/assets/img/step/stepActive03-03.png"),
        currentPath: "/enroll/quotation",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuotation",
      },
      {
        idx: 3,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/quotation",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["QUOTATION_AUDIT_PASS"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 4,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
    // 基金托管服务 – 定制化(不包括: 基金设立)
    FUND_ADMIN_CUSTOMIZED: [
      {
        idx: 0,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: null,
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 1,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/quotation",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 2,
        title: "enroll.quotation.quotation",
        defaultImg: require("@/assets/img/step/step03-03.png"),
        activeImg: require("@/assets/img/step/stepActive03-03.png"),
        currentPath: "/enroll/quotation",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuotation",
      },
      {
        idx: 3,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/quotation",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["QUOTATION_AUDIT_PASS"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 4,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
  },
  Malaysia: {
    // 公司设立
    COMPANY_INCORPORATION: [
      {
        idx: 0, // 索引
        title: "enroll.intitle.intitle", // 标题
        defaultImg: require("@/assets/img/step/step01.png"), // 默认图片
        activeImg: require("@/assets/img/step/stepActive01.png"), // 选中图片
        currentPath: "/enroll/intitle", // 当前路径
        prevPath: null, // 上一步路径
        nextPath: "/enroll/questionnaire", // 下一步路径
        supportApplymentStatusMap: {
          list: ["DRAFT"], // 支持进入该页面的申请状态
          violateMessage: "common.warning.alreadySubmit", // 违反(不在支持申请状态列表中)进入该页面时，提示的信息
        },
        componentName: "EnrollIntitle", // 组件名称(用于affirm、detail页)
      },
      {
        idx: 1,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: "/enroll/intitle",
        nextPath: "/enroll/establish",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 2,
        title: "enroll.establish.malaysia.businessInformation",
        defaultImg: require("@/assets/img/step/step03.png"),
        activeImg: require("@/assets/img/step/stepActive03.png"),
        currentPath: "/enroll/establish",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollEstablish",
      },
      {
        idx: 3,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/establish",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 4,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 5,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
    // 公司服务的转移 – 公司秘书相关的服务
    SERVICE_TRANSFER: [
      {
        idx: 0,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: null,
        nextPath: "/enroll/establish",
        supportApplymentStatusMap: {
          list: ["DRAFT"], // 支持进入该页面的申请状态
          violateMessage: "common.warning.alreadySubmit", // 违反(不在支持申请状态列表中)进入该页面时，提示的信息
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 1,
        title: "enroll.establish.malaysia.businessInformation",
        defaultImg: require("@/assets/img/step/step03.png"),
        activeImg: require("@/assets/img/step/stepActive03.png"),
        currentPath: "/enroll/establish",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollEstablish",
      },
      {
        idx: 2,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/establish",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 3,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["DRAFT"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 4,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
    // 综合性公司服务 – 定制化(不包括:公司设立)
    COMPREHENSIVE_CUSTOMIZED: [
      {
        idx: 0,
        title: "enroll.questionnaire.questionnaire",
        defaultImg: require("@/assets/img/step/step02.png"),
        activeImg: require("@/assets/img/step/stepActive02.png"),
        currentPath: "/enroll/questionnaire",
        prevPath: null,
        nextPath: "/enroll/upload",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuestionnaire",
      },
      {
        idx: 1,
        title: "enroll.upload.upload",
        defaultImg: require("@/assets/img/step/step04.png"),
        activeImg: require("@/assets/img/step/stepActive04.png"),
        currentPath: "/enroll/upload",
        prevPath: "/enroll/questionnaire",
        nextPath: "/enroll/quotation",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL", "REJECTED"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollUpload",
      },
      {
        idx: 2,
        title: "enroll.quotation.quotation",
        defaultImg: require("@/assets/img/step/step03-03.png"),
        activeImg: require("@/assets/img/step/stepActive03-03.png"),
        currentPath: "/enroll/quotation",
        prevPath: "/enroll/upload",
        nextPath: "/enroll/affirm",
        supportApplymentStatusMap: {
          list: ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"],
          violateMessage: "common.warning.alreadySubmit",
        },
        componentName: "EnrollQuotation",
      },
      {
        idx: 3,
        title: "enroll.affirm.affirm",
        defaultImg: require("@/assets/img/step/step05.png"),
        activeImg: require("@/assets/img/step/stepActive05.png"),
        currentPath: "/enroll/affirm",
        prevPath: "/enroll/quotation",
        nextPath: "/enroll/payment",
        supportApplymentStatusMap: {
          list: ["QUOTATION_AUDIT_PASS"],
          violateMessage: "common.warning.alreadySubmit",
        },
      },
      {
        idx: 4,
        title: "payment.payment",
        defaultImg: require("@/assets/img/step/step06.png"),
        activeImg: require("@/assets/img/step/stepActive06.png"),
        currentPath: "/enroll/payment",
        prevPath: "/enroll/affirm",
        nextPath: null,
      },
    ],
  },
};
